export class MetadataService {
    static parseMetadata(meta){
        console.log({meta});
        meta.content = typeof meta.content === "string" ? JSON.parse(meta.content) : meta.content;
        return meta;
    }
}